import { useEffect, useRef, useState } from "react";
import { getIMurData } from "../../services/reportService";
import { sortByDate } from "./_utils";
import { Eng2Chi } from "./_config";
import { useInfiniteScroll } from "ahooks";
import { dbiPageLogMes } from "@/pages/intelligence/utils/buriedPointCfg"
import { buriedPointPage, buriedPointSearch } from "@/pages/home/utils/buriedPoint";

export default (props) => {
  const [newsDataFull, setNewsDataFull] = useState([]);
  const [newsData1P, setNewsData1P] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [activeId, setActiveId] = useState('all');
  const [dataLoading, setLoading] = useState(true);
  const [segmentValue, setSegmentValue] = useState("all");
  const [type, setType] = useState('all');
  const [dataShow, setDataShow] = useState([]);
  const [dataAfterSearch, setDataAfterSearch] = useState([]);
  const debounce = useRef({ interval: 0, delay: 500}).current;

  const lazyScrollRef = useRef<HTMLDivElement>(null);

  const pageLogMes = dbiPageLogMes.iMurReports;

  interface Result {
    list: [];
    nextId: number | undefined;
  }

  const getIMurDataList = async () => {
    setLoading(true);
    try {
      const param = {"language_type": "all"}
      const res = await getIMurData(param)
      const data = sortByDate(res?.data)
      const temp = [];
      data.forEach((item, idx) => {
        let field = item["ext_field"];
        let fieldList
        if (field.length > 0) {
          let tag = field[field.length - 1].split('-');
          fieldList = [...tag]
        }
        fieldList = fieldList?.filter(item => {
          return item.indexOf('海外') == -1
        })
        // 删除字符串中所带</em>标签
        fieldList = fieldList?.map(item => {
          return item?.replace('</em>', '')
        })
        let itemUrl = item['url'];
        let nowUrl = window.location.href;
        if (nowUrl.indexOf('intlgame') != -1) {
            itemUrl = itemUrl.replace(/^https:\/\/[^/]+/, "https://insight.imur.tencent.com")
            itemUrl = itemUrl.replace(/^http:\/\/[^/]+/, "http://insight.imur.tencent.com")
        } else if (nowUrl.indexOf('woa') != -1) {
            itemUrl = itemUrl.replace(/^https:\/\/[^/]+/, "https://imur.woa.com")
            itemUrl = itemUrl.replace(/^http:\/\/[^/]+/, "http://imur.woa.com")
        }
        let obj = {
          isNew: true,
          key: idx,
          link: itemUrl,
          coverImg: item.cover_pic,
          title: item.title,
          summary: item.introduction,
          time: item.output_at,
          labelList: fieldList,
          source: "iMur",
          lang: item.lang,
          openid: item.openid
        }

        temp.push(obj);
      })
      setNewsDataFull(temp)
      setNewsData1P(temp)
      setDataShow(temp)
      setDataAfterSearch(temp)
      setLoading(false);
    } catch(e) {
      console.log(e)
    }
  }

  const debounceSearchChange = (word: string) => {
    clearTimeout(debounce.interval);
    //@ts-ignore
    debounce.interval = setTimeout(() => {
      searchFilterData(word);
      if (pageLogMes?.pageId) {
        buriedPointSearch(
          { extInfo: pageLogMes?.pageId, typeId: pageLogMes?.typeId },
          word,
        );
      }
    }, debounce.delay);
  }

  const searchFilterData = (word: string) => {
    let newData = [];
    if (typeof word === 'string' && word === '') {
      newData = dataShow;
    } else {
      dataShow.forEach((item, idx) => {
        let title = item.title;
        if (title.toUpperCase().indexOf(word.toUpperCase()) != -1) {
          let itemUpper = title.toUpperCase();
          let replaceWord = title.substr(itemUpper.indexOf(word.toUpperCase()), word.length);
          let replaceHtml = `<span style="color:#326ff0">${replaceWord}</span>`;
          const regExp = new RegExp(replaceWord, 'gi');
          let newTitle = title.replace(regExp, replaceHtml);

          let obj = {...item, key: idx, title: newTitle}

          newData.push(obj)
        }
      })
    }
    setDataAfterSearch(newData)
  }

  function getLoadMoreList(nextId: number | undefined, limit: number): Promise<Result> {
    let start = 0;
    if (nextId) {
      start = dataAfterSearch.findIndex((i) => i.key === nextId);
    }
    const end = start + limit;
    const list = dataAfterSearch.slice(start, end);
    const nId = dataAfterSearch[end] ? dataAfterSearch[end].key : undefined;

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          list,
          nextId: nId,
        });
      }, 500);
    });
  }

  const { data, loading, loadingMore, noMore } = useInfiniteScroll(
    (d) =>{
      // console.log(d)
      return getLoadMoreList(d?.nextId, 6)
    },
    {
      target: lazyScrollRef,
      isNoMore: (d) => d?.nextId === undefined,
      reloadDeps: [dataAfterSearch]
    },
  );

  useEffect(() => {
    getIMurDataList();
    buriedPointPage(pageLogMes);
  }, [])

  useEffect(() => {
    if (activeId === 'all') {
      setNewsData1P(newsDataFull)
      setDataShow(newsDataFull)
      setDataAfterSearch(newsDataFull)
    } else {
      const tmpData = newsDataFull.filter((item, index) => {
        return item.labelList.indexOf(Eng2Chi[activeId]) != -1;
      })
      setNewsData1P(tmpData)
      setDataShow(tmpData)
      setDataAfterSearch(tmpData)
    }
    setSegmentValue('all')
    setSearchValue('')
  }, [activeId])


  useEffect(() => {
    let tmp = newsData1P;
    if (segmentValue != 'all') {
      tmp = tmp.filter((item, index) => {
        return item.labelList.indexOf(segmentValue) != -1
      })
    }
    if (type != 'all') {
      tmp = tmp.filter((item, index) => {
        return item.lang == type
      })
    }
    setDataShow(tmp)
    setDataAfterSearch(tmp)
    setSearchValue('')
  }, [segmentValue, type])
  

  return {
    dataAfterSearch,
    activeId,
    setActiveId,
    dataLoading,
    segmentValue,
    setSegmentValue,
    type,
    setType,
    searchValue,
    setSearchValue,
    debounceSearchChange,
    lazyScrollRef,
    data, 
    loading, 
    loadingMore, 
    noMore
  }
}